import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const appName = (environment as { appName?: string }).appName ?? '@ec/fleet-dashboard-v2';
const appVersion = (environment as { appVersion?: string }).appVersion ?? 'unknown';

console.info(`${appName} version ${appVersion}`);

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
